<script>
    import { getContext } from "svelte";
    import { colorScale } from "../scripts/helpers.js";
    const { height } = getContext("LayerCake");

    export let legend_rect_spacing;
    export let onMouseEvents;

    $: padding = 20;
    $: legend_color_y = $height / 2
    $: legend_color_y = $height / (onMouseEvents ? 2 : 4);

</script>

{#each { length: 5 } as _, i}
    <rect
        class="legend-rect"
        transform={`translate(${padding + legend_rect_spacing * i}, ${legend_color_y})`}
        fill={colorScale(0.25 * i)}
        width={legend_rect_spacing}
        height="8"
    />
{/each}

<text class="legend-text" transform={`translate(${padding}, ${legend_color_y + 20})`}>
    0%
</text>

<text
    class="legend-text legend-text-end"
    transform={`translate(${padding + legend_rect_spacing * 5}, ${legend_color_y + 20})`}
>
    100%
</text>

<rect
    transform={`translate(${padding}, ${legend_color_y})`}
    fill-opacity="0"
    stroke="var(--gray-90)"
    stroke-width="0.25"
    width={legend_rect_spacing * 5}
    height="8"
/>

<style lang="scss">
    .legend-text {
        text-anchor: start;
        font-size: var(--scale-3);
        fill: var(--gray-40);
        font-weight: 400;
    }

    .legend-text-end {
        text-anchor: end;
    }

    .legend-rect {
        fill-opacity: 0.6;
        stroke-opacity: 1;
    }
</style>
